import { render } from "./Admin.vue?vue&type=template&id=0d84be6c"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=0d84be6c&lang=css"
script.render = render

export default script